import React from 'react';

import CompaniesPage from '../components/CompaniesPage';

const Companies = () => (
  <CompaniesPage
    lang="ptbr"
    title="Empresas Parceiras | Full Stack Aberto"
    seoDescription="Desenvolvimento Full Stack em empresas parceiras"
  />
);

export default Companies;
